import React, { FC } from 'react';
import clsx from 'clsx';
import secondaryPriceTotalStyles from './secondaryPriceTotalStyles';
import usePlatformConfig from '../../../../../../../common/react/usePlatformConfig';
import { IPrice } from '../../../../../../../../../common/model/IPrice';
import Price from '../../../../../../../common/components/presentation/Price';
import Translation from '../../../../../../../common/components/translation/Translation';

export interface ISecondaryTotalPriceProps {
  secondaryTotal: IPrice;
  classes?: {
    price?: string;
  };
}

const SecondaryPriceTotal: FC<ISecondaryTotalPriceProps> = ({ secondaryTotal, classes }) => {
  const styles = secondaryPriceTotalStyles();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();

  return (
    <Translation
      id="spc.configuratorSummary.secondary"
      values={{
        price: (
          <Price
            component="span"
            className={clsx([styles.inlinePrice, classes?.price])}
            price={secondaryTotal?.basePrice}
            currency={secondaryTotal?.currency}
            decimals={priceDisplay.secondary?.decimalScale}
            data-test="text:price:secondary_currency_value"
          />
        ),
      }}
    />
  );
};

export default SecondaryPriceTotal;
